import { render, staticRenderFns } from "./SalesAppraisal.vue?vue&type=template&id=5d2765d6&scoped=true&"
import script from "./SalesAppraisal.vue?vue&type=script&lang=ts&"
export * from "./SalesAppraisal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2765d6",
  null
  
)

export default component.exports